import { platform } from '~/lib/params'
import { m } from '~/paraglide/messages'

export function FooterDescription() {
  if (platform === 'china_android') return null
  return (
    <p class="w-full text-center text-xs text-white/60">
      {m.subscription_walkthrough_p4_footer_notes()}
    </p>
  )
}
